import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiDropGroupMention } from "@/generated/models/ApiDropGroupMention";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import WaveDropPart from "./WaveDropPart";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ImageScale } from "@/helpers/image.helpers";
import useIsTouchDevice from "@/hooks/useIsTouchDevice";
import type { DropContentPresentation } from "./dropContentPresentation";
import WaveDropPoll from "./poll/WaveDropPoll";
interface WaveDropContentProps {
  readonly drop: ExtendedDrop;
  readonly activePartIndex: number;
  readonly setActivePartIndex: (index: number) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly onLongPress: () => void;
  readonly setLongPressTriggered: (triggered: boolean) => void;
  readonly isEditing?: boolean | undefined;
  readonly isSaving?: boolean | undefined;
  readonly onSave?: ((newContent: string, mentions?: ApiDropMentionedUser[], mentionedGroups?: ApiDropGroupMention[], mentionedWaves?: ApiMentionedWave[]) => void) | undefined;
  readonly onCancel?: (() => void) | undefined;
  readonly isCompetitionDrop?: boolean | undefined;
  readonly mediaImageScale?: ImageScale | undefined;
  readonly mediaContainerHeightClassName?: string | undefined;
  readonly fullWidthMedia?: boolean | undefined;
  readonly fullWidthLinkPreviews?: boolean | undefined;
  readonly hasTouch?: boolean | undefined;
  readonly onLinkCardActionsActiveChange?: ((href: string, active: boolean) => void) | undefined;
  readonly contentPresentation?: DropContentPresentation | undefined;
  readonly embedPath?: readonly string[] | undefined;
  readonly quotePath?: readonly string[] | undefined;
  readonly embedDepth?: number | undefined;
  readonly maxEmbedDepth?: number | undefined;
}
const WaveDropContent: React.FC<WaveDropContentProps> = t0 => {
  const $ = _c(30);
  const {
    drop,
    activePartIndex,
    setActivePartIndex,
    onDropContentClick,
    onQuoteClick,
    onLongPress,
    setLongPressTriggered,
    isEditing: t1,
    isSaving: t2,
    onSave,
    onCancel,
    isCompetitionDrop: t3,
    mediaImageScale: t4,
    mediaContainerHeightClassName,
    fullWidthMedia: t5,
    fullWidthLinkPreviews: t6,
    hasTouch,
    onLinkCardActionsActiveChange,
    contentPresentation: t7,
    embedPath,
    quotePath,
    embedDepth,
    maxEmbedDepth
  } = t0;
  const isEditing = t1 === undefined ? false : t1;
  const isSaving = t2 === undefined ? false : t2;
  const isCompetitionDrop = t3 === undefined ? false : t3;
  const mediaImageScale = t4 === undefined ? ImageScale.AUTOx450 : t4;
  const fullWidthMedia = t5 === undefined ? false : t5;
  const fullWidthLinkPreviews = t6 === undefined ? false : t6;
  const contentPresentation = t7 === undefined ? "default" : t7;
  const isTouchDevice = useIsTouchDevice();
  const effectiveHasTouch = hasTouch ?? isTouchDevice;
  let t8;
  if ($[0] !== activePartIndex || $[1] !== contentPresentation || $[2] !== drop || $[3] !== effectiveHasTouch || $[4] !== embedDepth || $[5] !== embedPath || $[6] !== fullWidthLinkPreviews || $[7] !== fullWidthMedia || $[8] !== isCompetitionDrop || $[9] !== isEditing || $[10] !== isSaving || $[11] !== maxEmbedDepth || $[12] !== mediaContainerHeightClassName || $[13] !== mediaImageScale || $[14] !== onCancel || $[15] !== onDropContentClick || $[16] !== onLinkCardActionsActiveChange || $[17] !== onLongPress || $[18] !== onQuoteClick || $[19] !== onSave || $[20] !== quotePath || $[21] !== setActivePartIndex || $[22] !== setLongPressTriggered) {
    t8 = <WaveDropPart drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onDropContentClick={onDropContentClick} onQuoteClick={onQuoteClick} onLongPress={onLongPress} setLongPressTriggered={setLongPressTriggered} isEditing={isEditing} isSaving={isSaving} onSave={onSave} onCancel={onCancel} isCompetitionDrop={isCompetitionDrop} mediaImageScale={mediaImageScale} mediaContainerHeightClassName={mediaContainerHeightClassName} fullWidthMedia={fullWidthMedia} fullWidthLinkPreviews={fullWidthLinkPreviews} hasTouch={effectiveHasTouch} onLinkCardActionsActiveChange={onLinkCardActionsActiveChange} contentPresentation={contentPresentation} embedPath={embedPath} quotePath={quotePath} embedDepth={embedDepth} maxEmbedDepth={maxEmbedDepth} />;
    $[0] = activePartIndex;
    $[1] = contentPresentation;
    $[2] = drop;
    $[3] = effectiveHasTouch;
    $[4] = embedDepth;
    $[5] = embedPath;
    $[6] = fullWidthLinkPreviews;
    $[7] = fullWidthMedia;
    $[8] = isCompetitionDrop;
    $[9] = isEditing;
    $[10] = isSaving;
    $[11] = maxEmbedDepth;
    $[12] = mediaContainerHeightClassName;
    $[13] = mediaImageScale;
    $[14] = onCancel;
    $[15] = onDropContentClick;
    $[16] = onLinkCardActionsActiveChange;
    $[17] = onLongPress;
    $[18] = onQuoteClick;
    $[19] = onSave;
    $[20] = quotePath;
    $[21] = setActivePartIndex;
    $[22] = setLongPressTriggered;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== drop || $[25] !== isEditing) {
    t9 = !isEditing && drop.poll && <WaveDropPoll drop={drop} />;
    $[24] = drop;
    $[25] = isEditing;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t8 || $[28] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[27] = t8;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
};
export default WaveDropContent;